var map = {
	"./AIAlgoTrading.png": 9784,
	"./BinaryOptions.png": 3402,
	"./JavaScriptCompiler.png": 4109,
	"./OptionsPricing.png": 3451,
	"./PairsTrading.png": 2988,
	"./PortfolioAllocationModels.png": 8624,
	"./Varun.jpg": 5281,
	"./data": 6914,
	"./data.json": 6914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;